import * as React from 'react'
import { ChevronsUpDown } from '@/lib/icons'
import { cn } from '@/lib/utils'

interface ComboboxTriggerProps extends React.ComponentProps<'button'> {
  placeholder?: string
  value?: string
}

function ComboboxTrigger({
  className,
  placeholder = 'Select...',
  value,
  ...props
}: ComboboxTriggerProps) {
  return (
    <button
      type="button"
      data-slot="combobox-trigger"
      className={cn(
        'shadow-xs flex h-9 w-full cursor-pointer items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 py-1 text-base text-foreground outline-none transition-[color,box-shadow]',
        'hover:bg-transparent hover:text-foreground',
        'focus-visible:ring-accent-lilac/50 focus-visible:border-accent-lilac focus-visible:ring-[3px]',
        'dark:bg-input/30 dark:hover:bg-input/30',
        '[&[aria-invalid=true]]:border-destructive [&[aria-invalid=true]]:ring-destructive-50 [&[aria-invalid=true]:focus-visible]:border-destructive [&[aria-invalid=true]:focus-visible]:ring-destructive-50',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <span className={cn('truncate', !value && 'text-muted-foreground')}>
        {value || placeholder}
      </span>
      <ChevronsUpDown className="size-4 shrink-0 opacity-50" />
    </button>
  )
}

export { ComboboxTrigger }
export type { ComboboxTriggerProps }
